// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"7d6e0c63704133f76c3a","655":"5f0f975592d1dfb9e48e"}[chunkId] + ".js";
};